<template>
  <router-view />
</template>

<script>
export default {
  name: 'KernelInputMessagesWrapper',
};
</script>
